import { Avatar, Chip, Grid, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../constants/FieldsConst';
import { dateformat, textLabels } from '../../../helpers';
import { LoadingWidget } from '../../../widgets';
import { getFilesArchivos } from '../../archivos/HelpersArchivos';
import { NameComponent } from '../../usuario/usuarios/components/ListadoUsuarios';
import { rolesArray } from '../../usuario/usuarios/components/SelectFieldRoles';
import { allAccesosAction } from '../AccesosAction';
import { PARAMS_ACCESOS } from '../AccesosReducer';

const ListadoAccesos = () => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const accesosStore = Redux.useSelector((state) => state.accesos);

  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    async function fetchData() {
      const payload = {
        ...accesosStore.params,
        idEntidad: entidadesStore.activo.id,
      };
      dispatch({ type: PARAMS_ACCESOS, payload });
      if (accesosStore.all && accesosStore.all.length === 0) {
        await allAccesosAction(dispatch, payload);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const list = accesosStore.all.map((el) => {
      return {
        ...el,
        rol: el.usuario.rol,
        avatar: el.usuario.perfil.avatar,
        role: 'Usuario',
      };
    });
    setRows(list);
  }, [accesosStore.all]);

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: 'avatar',
      label: CONST.foto.label,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Avatar
              alt={value.nombre}
              sx={{ width: 40, height: 40, marginRight: 1 }}
              src={getFilesArchivos(value.avatar)}
            />
          );
        },
      },
    },
    {
      name: CONST.usuario.name,
      label: CONST.usuario.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent>
              {value.perfil.dni} {value.perfil.pnombre} {value.perfil.papellido}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.rol.name,
      label: CONST.rol.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography variant="body1" color="initial">
              {rolesArray[value]}
            </Typography>
          );
        },
      },
    },
    {
      name: CONST.entrada.name,
      label: CONST.entrada.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography>
              {dateformat(value, { format: 'DD-MM-YYYY hh:mm A' })}
            </Typography>
          );
        },
      },
    },
    {
      name: CONST.salida.name,
      label: CONST.salida.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? (
            <Typography>
              {dateformat(value, { format: 'DD-MM-YYYY hh:mm A' })}
            </Typography>
          ) : (
            <Chip size="small" label="No tiene salida marcada" color="error" />
          );
        },
      },
    },
    {
      name: CONST.segEntrada.name,
      label: CONST.segEntrada.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography>
              {value.perfil.pnombre} {value.perfil.papellido}
            </Typography>
          );
        },
      },
    },
    {
      name: CONST.segSalida.name,
      label: CONST.segSalida.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? (
            <Typography>
              {value.perfil.pnombre} {value.perfil.papellido}
            </Typography>
          ) : (
            ' --'
          );
        },
      },
    },
    // {
    //   name: CONST.actions.name,
    //   label: CONST.actions.label,
    //   options: {
    //     filter: false,
    //     sort: false,
    //     empty: true,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return (
    //         <Stack direction="row">
    //           {/* <ActionsListWidget
    //             id={tableMeta.rowData[0]}
    //             onEdit={() => _handleEditClick(tableMeta.rowData[0])}
    //             onDelete={async () => {
    //               const data = accesosStore.all.find(
    //                 (el) => el.id === tableMeta.rowData[0]
    //               );
    //               setIsDelete(true);
    //             }}
    //             onDownload={() => {
    //               const data = accesosStore.all.find(
    //                 (el) => el.id === tableMeta.rowData[0]
    //               );
    //               window.open(data.url);
    //             }}
    //           /> */}
    //         </Stack>
    //       );
    //     },
    //   },
    // },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },

    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
    serverSide: true,
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={accesosStore.loadingAll} />
        <MUIDataTable
          title={'Listado'}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
    </Grid>
  );
};

export default ListadoAccesos;
